import { TRepost } from './types'

export const getUndoRepostProps = (props: TRepost) => {
  const { canRepost, canUndoRepost, isHighlighted, isFeedAuthor } = props

  const isActiveUndoRepost = isHighlighted && canUndoRepost
  const isDisabledRepost = (!canRepost && !isActiveUndoRepost) || isFeedAuthor

  return { isDisabledRepost, isActiveUndoRepost }
}
